import { Badge } from '@retainerclub/common';
import PropTypes from 'prop-types';

function TableRowColumnAddress({ address, sendToClinic }) {
  return address ? (
    <>
      {address.address}
      <br />
      {address.address2 !== null &&
        address.address2 !== undefined &&
        address.address2 !== '' && (
          <>
            {address.address2}
            <br />
          </>
        )}
      {address.city}, {address.state} {address.zip}
      {sendToClinic && (
        <Badge
          name="Shipped To your Provider"
          color="green"
          size="sm"
          withDot={false}
        />
      )}
    </>
  ) : null;
}

TableRowColumnAddress.propTypes = {
  address: PropTypes.object.isRequired,
  sendToClinic: PropTypes.bool.isRequired,
};

export default TableRowColumnAddress;
